import { render, staticRenderFns } from "./CompareDataSources.vue?vue&type=template&id=cedfc594&"
import script from "./CompareDataSources.vue?vue&type=script&lang=js&"
export * from "./CompareDataSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports